'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { CdnImage } from '../../primitives/CdnImage';
import { Box, ButtonBase, Typography } from '@mui/material';
import { PlusIconWithDropShadow } from './PlusIconWithDropShadow';
export type CardOfferButtonMetadata = {
  id: string;
  name: string;
  imageUrl: string;
};
type CardOfferButtonProps = {
  cardOfferButton: CardOfferButtonMetadata;
  disabled: boolean;
};
export const CreditCardOfferButton = t0 => {
  const $ = _c(22);
  const {
    cardOfferButton,
    disabled
  } = t0;
  const [isHovering, setIsHovering] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      position: "relative"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsHovering(true);
    t3 = () => setIsHovering(false);
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== disabled || $[4] !== isHovering) {
    t4 = isHovering && !disabled && <Box sx={{
      position: "absolute",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
      top: 25,
      left: 0
    }}><PlusIconWithDropShadow /></Box>;
    $[3] = disabled;
    $[4] = isHovering;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = disabled ? 0.25 : 1;
  let t6;
  if ($[6] !== t5) {
    t6 = {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      opacity: t5
    };
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = `${cardOfferButton.name} Image`;
  let t8;
  if ($[8] !== cardOfferButton.imageUrl || $[9] !== t7) {
    t8 = <CdnImage width={127} height={78} src={cardOfferButton.imageUrl} alt={t7} draggable={false} />;
    $[8] = cardOfferButton.imageUrl;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      textAlign: "center"
    };
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== cardOfferButton.name) {
    t10 = <Box sx={_temp}><Typography variant="textSmall" paragraph={true} sx={t9}>{cardOfferButton.name}</Typography></Box>;
    $[12] = cardOfferButton.name;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t6 || $[16] !== t8) {
    t11 = <Box sx={t6}>{t8}{t10}</Box>;
    $[14] = t10;
    $[15] = t6;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== disabled || $[19] !== t11 || $[20] !== t4) {
    t12 = <ButtonBase disableRipple={true} sx={t1} disableTouchRipple={true} focusRipple={false} disabled={disabled} onMouseEnter={t2} onMouseLeave={t3}>{t4}{t11}</ButtonBase>;
    $[18] = disabled;
    $[19] = t11;
    $[20] = t4;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
};
function _temp(theme) {
  return {
    marginTop: theme.spacing(2),
    paddingX: theme.spacing(2)
  };
}